import React from 'react';
import { useEffect, useRef, useState } from 'react'
import {
  SActionBtn,
  SLowcodeList,
  SDrawer,
  STableActions,
} from 'shj-components'
import config from './config';
import { message, Table } from 'antd'
import { CollectionCountHtml } from './components/collectionCount.tsx'
import {fileConfirm} from '@/utils/file'
import dayjs from 'dayjs'
import { 
  transactionJournalFindListByPage,
  exportToExportTask,
  sendTransactionElecListByTransactionId
} from '@/services/fmsServices';
export default function PaymentServiceManage(props) {
  const { id, orderId } = props
  const [collectionCountModal, setCollectionCountModal] = useState(false);
  const listRef = useRef<any>();

  useEffect(() => {
    reloadFn()
  }, [id])
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        const { paymentMethodList, verifyStateList, stateList, transactionTypeList } = query
        query.orderAccountId = id
        if (query.receivedDate) {
          query.receivedDateStart = dayjs(query.receivedDate[0]).format('YYYY-MM-DD 00:00:00')
          query.receivedDateEnd = dayjs(query.receivedDate[1]).format('YYYY-MM-DD 23:59:59')
        }
        // 将单值转换为数组形式
        paymentMethodList && (query.paymentMethodList = [paymentMethodList]);
        verifyStateList && (query.verifyStateList = [verifyStateList]);
        stateList && (query.stateList = [stateList]);
        transactionTypeList && (query.transactionTypeList = [transactionTypeList]); 
        transactionJournalFindListByPage(current, pageSize, query).then((res)=>{
          resolve(res)
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };

  const onCollectionCount = () => {
    setCollectionCountModal(true)
  }

  //下载收据信息
  const downReceipt = (record: any) => {
    // 以前直接下载
    // window.open(removeExtraSlashes(`${baseURL}${UrlConfig.PlusFmsWeb.DownloadTransactionElecList}?transactionId=${record.id}&Authorization=${getToken()}`));
    // 走下载中心
    message.loading({ content: '导出中' })
    exportToExportTask({transactionId:record.id}).then((res)=>{
      if (res.status) {
        message.destroy()
        fileConfirm()
      } else {
        message.error('下载失败')
        message.destroy()
      }
    })
  };

  const sendReceipt = (record: any) => {
    message.loading({ content: '发送中...' })
    sendTransactionElecListByTransactionId(record.id).then((res:any)=>{
      message.success(res.message || '发送成功')
      reloadFn()
    })
  }

  // 右侧表格配置
  const extension = {
    request: { fetchList },
    events: { onCollectionCount },
    getCheckboxProps: (item)=>({
      disabled: item.state !== 'receiveToAccount'
    }),
    customRender: {
      renderOperate(_, record: Record<string, any>) {
        return (
          <STableActions>
            {
              record.state === 'receiveToAccount'||record.state === 'confirmToAccount' ?<SActionBtn auth="orderSendReceipt" onClick={() => sendReceipt(record)}>发送收据信息</SActionBtn>:null
            }
            {
              record.state === 'receiveToAccount'||record.state === 'confirmToAccount' ?<SActionBtn auth="orderDownloadReceipt" onClick={() => downReceipt(record)}>下载收据信息</SActionBtn>:null
            }
          </STableActions>
        )
      },
    },
  }
  return (
    <div>
      <SLowcodeList config={config} tableType="antd" ref={listRef} {...extension} 
        searchMode="group"
        summary={() => {
          const dataSource = listRef.current?.getDataSource() || [];
          if (dataSource.length === 0) {
            return null; // 没有数据时不显示 Table.Summary
          }

          const totalAmounts = dataSource.reduce(
            (totals, record) => {
              totals.receivable += parseFloat(record.amount) || 0;
              totals.verified += parseFloat(record.verifiedAmount) || 0;
              totals.unverified += parseFloat(record.unverifiedAmount) || 0;
              return totals;
            },
            { receivable: 0, verified: 0, unverified: 0 }
          );

          const formatAmount = (amount) => Number(amount).toFixed(2);

          return (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}></Table.Summary.Cell>
                <Table.Summary.Cell index={1}></Table.Summary.Cell>
                <Table.Summary.Cell index={2}>合计</Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                  {formatAmount(totalAmounts.receivable)}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          );
        }}
      />
       {/* 收款计算 */}
       <SDrawer
        title={'收款计算'}
        width="60%"
        isHideResetBtn={false}
        footer={[]}
        open={collectionCountModal}
        onClose={() => setCollectionCountModal(false)}
        destroyOnClose
      >
        <CollectionCountHtml orderId={orderId} />
      </SDrawer>
    </div>
  )
}
